import {
  FilePreviewStyled,
  FileViewerControlsSectionStyled,
  FileViewerStyled,
} from '@procurify/ui'
import styled from 'styled-components'

export const ExpenseLineItemDrawerDocumentStyled = styled.div`
  width: 100%;
  height: 100%;

  ${FileViewerStyled}, ${FilePreviewStyled} {
    background-color: transparent;
  }

  ${FileViewerControlsSectionStyled} {
    padding: 1rem;
  }

  .fileviewer-emptystate-container {
    background-color: ${(props) => props.theme.colors.contentBackground};
    border-radius: ${(props) => props.theme.box.borderRadius(10)};
  }
`
